<!--
    描述：会议室预约记录
    作者：asq
-->
<template>
	<div class="h100 audit">
	  <filter-layout
		@search="searchResult"
		@reset="resetSearch"
		v-if="!routeQuery"
		hasMore
	  >
		<template #filter>
		  <el-form
			class="flex-row-form colspan-4"
			size="small"
			ref="searchForm"
			label-width="100px"
			:model="searchObj"
		  >
			<el-form-item label="会议室名称：">
			  <el-input
				:placeholder="'请输入'"
				clearable
				v-model="searchObj.meetingName"
				size="small"
			  >
			  </el-input>
			</el-form-item>
			<el-form-item label="项目名称：">
			  <el-input
				:placeholder="'请输入'"
				clearable
				v-model="searchObj.projectName"
				size="small"
			  >
			  </el-input>
			</el-form-item>
			<el-form-item label="预约单位：">
			  <el-input
				:placeholder="'请输入'"
				clearable
				v-model="searchObj.companyName"
				size="small"
			  >
			  </el-input>
			</el-form-item>
			<el-form-item label="预约人：">
			  <el-input
				:placeholder="'请输入'"
				clearable
				v-model="searchObj.userName"
				size="small"
			  >
			  </el-input>
			</el-form-item>
		  </el-form>
		</template>
		<template #more>
		  <el-form
			class="flex-row-form colspan-4"
			size="small"
			ref="searchForm"
			label-width="100px"
			:model="searchObj"
		  >
			<el-form-item label="归属场地：">
			  <el-input
				:placeholder="'请输入'"
				clearable
				v-model="searchObj.ascriptionName"
				size="small"
			  >
			  </el-input>
			</el-form-item>
			<el-form-item label="预约时间：">
			  <el-date-picker
				v-model="searchObj.bookTime"
				type="daterange"
				unlink-panels
				start-placeholder="请选择"
				end-placeholder="请选择"
				:default-time="['00:00:00', '23:59:59']"
				size="small"
			  >
			  </el-date-picker>
			</el-form-item>
			<el-form-item label="预约来源：">
			  <el-select
				v-model="searchObj.sysCode"
				placeholder="请选择"
				clearable
				size="small"
			  >
				<el-option label="能工社运营管理平台" value="1001"></el-option>
				<el-option label="能工社公共交易平台" value="1002"></el-option>
				<el-option label="安招采业务系统" value="1003"></el-option>
				<el-option label="专家评审项目" value="1004"></el-option>
				<el-option label="资源价格系统" value="1005"></el-option>
			  </el-select>
			</el-form-item>
			<el-form-item label="预约状态：">
			  <el-select
				v-model="searchObj.meetingStatus"
				placeholder="请选择"
				clearable
				size="small"
			  >
				<el-option label="预约中" value="0"></el-option>
				<el-option label="占用中" value="1"></el-option>
				<el-option label="已结束" value="2"></el-option>
				<el-option label="已释放" value="3"></el-option>
				<el-option label="锁定中" value="4"></el-option>
			  </el-select>
			</el-form-item>
		  </el-form>
		</template>
		<template #content>
		  <div class="content-header">
			<div class="title">
			  预约记录合计： <span class="blue">{{ tableObj.total }}</span> 条
			</div>
		  </div>
		  <div class="w-table-layout w-table-page">
			<div class="w-table-content">
			  <el-table
				ref="xTable"
				:data="tableObj.data"
				highlight-current-row
				height="100%"
				border
			  >
				<el-table-column
				  type="index"
				  label="序号"
				  align="center"
				  width="80"
				></el-table-column>
				<el-table-column
				  prop="sysNo"
				  label="预约流水号"
				  header-align="center"
				  width="150"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="meetingName"
				  label="会议室名称"
				  header-align="center"
				  width="130"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="createDate"
				  label="预约时间"
				  align="center"
				  width="180"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="projectName"
				  label="项目名称"
				  header-align="center"
				  min-width="180"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="companyName"
				  label="预约单位"
				  header-align="center"
				  width="180"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="userName"
				  label="预约人"
				  align="center"
				  width="120"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="occupancyTime"
				  label="占用时间"
				  align="center"
				  width="180"
				  show-overflow-tooltip
				></el-table-column>
				<el-table-column
				  prop="ascriptionName"
				  label="归属场地"
				  align="center"
				  width="120"
				  show-overflow-tooltip
				>
				</el-table-column>
				<el-table-column
				  prop="sysCode"
				  label="预约来源"
				  align="center"
				  width="100"
				  show-overflow-tooltip
				>
				  <template slot-scope="scope">
					<span v-if="scope.row.sysCode == 1001"
					  >能工社运营管理平台</span
					>
					<span v-if="scope.row.sysCode == 1002"
					  >能工社公共交易平台</span
					>
					<span v-if="scope.row.sysCode == 1003">安招采业务系统</span>
					<span v-if="scope.row.sysCode == 1004">专家评审项目</span>
					<span v-if="scope.row.sysCode == 1005">资源价格系统</span>
					<span v-if="scope.row.sysCode == 1016007">实施作业系统</span>
					<span v-if="scope.row.sysCode == 1021002">经营作业系统</span>
				  </template>
				</el-table-column>
				<el-table-column
				  prop="meetingStatus"
				  label="预约状态"
				  align="center"
				  width="120"
				  show-overflow-tooltip
				>
				  <template slot-scope="scope">
					<span :class="dealClass(scope.row.meetingStatus)">
					  {{ dealTitle(scope.row.meetingStatus) }}
					</span>
				  </template>
				</el-table-column>
				<el-table-column align="center" width="100">
				  <template slot="header">操作</template>
				  <template slot-scope="scope">
					<el-button
					  type="primary"
					  size="small"
					  round
					  plain
					  class="table-btn"
					  v-if="roleBtns.includes('recordDetail')"
					  @click="detailView(scope.row)"
					>
					  <svg-icon icon-class="form-details"></svg-icon> 详情
					</el-button>
				  </template>
				</el-table-column>
			  </el-table>
			</div>
			<div class="w-table-footer">
			  <el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="tableObj.currentPage"
				:page-sizes="tableObj.pageList"
				:page-size="tableObj.pageSize"
				:total="tableObj.total"
				layout="total, sizes, prev, pager, next, jumper"
			  >
			  </el-pagination>
			</div>
		  </div>
		</template>
	  </filter-layout>
	  <div class="operation-main" v-if="routeQuery">
		<reply-detail ref="replyDetail" :detail="detail"></reply-detail>
	  </div>
	</div>
  </template>
<script>
import { getRoomList } from "api/modules/fieldManagement";
import { dateFormat } from "utils/tools";
import { mapState } from "vuex";

import replyDetail from "./components/reply-detail";

export default {
	name: '',
	components: {
		replyDetail,
	},
	data() {
		return {
			detail: {},
			searchToggle: true,
			loading: true,
			searchObj: {
				meetingName: '',
				projectName: '',
				companyName: '',
				userName: '',
				ascriptionName: '',
				bookTime: '',
				sysCode: '',
				meetingStatus: '',
			},
			tableObj: {
				data: [],
				currentPage: 1, // 当前页码
				pageList: [10, 20, 50, 100], // 显示条数数组
				pageSize: 10, // 当前显示条数
				total: 0, // 当前总条数
			},
		}
	},
	computed: {
		...mapState('app', {
			isBack: (state) => state.isBack,
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
		routeQuery() {
			return this.$route.query.type
		},
	},
	created() {
		// 如果是 返回的
		if (this.isBack) {
			if (this.$getSessionItem('searchForm')) {
				this.searchObj = JSON.parse(this.$getSessionItem('searchForm'))

				// 移除 避免污染
				this.$removeSessionItem('searchForm')
			}

			if (this.$getSessionItem('currentPage')) {
				this.tableObj.currentPage = JSON.parse(
					this.$getSessionItem('currentPage')
				)

				// 移除 避免污染
				this.$removeSessionItem('currentPage')
			}

			if (this.$getSessionItem('pageSize')) {
				this.tableObj.pageSize = JSON.parse(
					this.$getSessionItem('pageSize')
				)

				// 移除 避免污染
				this.$removeSessionItem('pageSize')
			}
		}

		this.getTablePageList()
	},
	methods: {
		// 搜索
		searchResult() {
			this.tableObj.currentPage = 1
			this.getTablePageList()
		},

		// 获取预约记录
		getTablePageList() {
			if (
				this.searchObj.bookTime != '' &&
				this.searchObj.bookTime != null
			) {
				//this.searchObj.useStartTime = new Date(dateFormat('',this.searchObj.bookTime[0]))
				//this.searchObj.useEndTime = new Date(dateFormat('',this.searchObj.bookTime[1]))
				//this.searchObj.useStartTime = this.searchObj.bookTime[0]
				//this.searchObj.useEndTime = this.searchObj.bookTime[1]
				this.searchObj.orderStartTime = dateFormat(
					'',
					this.searchObj.bookTime[0]
				)
				this.searchObj.orderEndTime = dateFormat(
					'',
					this.searchObj.bookTime[1]
				)
			} else {
				this.searchObj.orderStartTime = ''
				this.searchObj.orderEndTime = ''
			}
			let params = Object.assign({}, this.searchObj)
			this.loading = true
			// 分页参数
			params.current = this.tableObj.currentPage
			params.size = this.tableObj.pageSize
			getRoomList(params)
				.then((res) => {
					this.loading = false
					if (res.data.pageList) {
						this.tableObj.data = res.data.pageList.records
						this.tableObj.total = parseInt(res.data.pageList.total)
					} else {
						this.tableObj.data = res.data.records
						this.tableObj.total = parseInt(res.data.total)
					}

					// this.tableObj.currentPage = parseInt(
					// 	res.data.pageList.current
					// )
					// this.tableObj.pageSize = parseInt(res.data.pageList.size)
				})
				.catch((err) => {
					this.loading = false
				})
		},

		// 查看会议室详情
		detailView(row) {
			this.detail = row
			// 存值
			this.$setSessionItem('searchForm', JSON.stringify(this.searchObj))
			this.$setSessionItem(
				'currentPage',
				JSON.stringify(this.tableObj.currentPage)
			)
			this.$setSessionItem(
				'pageSize',
				JSON.stringify(this.tableObj.pageSize)
			)

			this.$router.push({
				name: 'room-records-reply',
				query: {
					type: 'detail',
					id: row.id,
				},
			})
		},

		// 重置
		resetSearch() {
			this.searchObj = {}
			this.tableObj.pageSize = 10
			this.tableObj.currentPage = 1
			this.getTablePageList()
		},

		// 切换显示条数
		handleSizeChange(val) {
			this.tableObj.pageSize = val
			this.getTablePageList()
		},

		//切换当前页码
		handleCurrentChange(val) {
			this.tableObj.currentPage = val
			this.getTablePageList()
		},

		// 处理状态
		dealTitle(data) {
			let msg = ''
			switch (data) {
				case 0:
					msg = '预约中'
					break
				case 1:
					msg = '占用中'
					break
				case 2:
					msg = '已结束'
					break
				case 3:
					msg = '已释放'
					break
				case 4:
					msg = '锁定中'
					break
			}
			return msg
		},

		// 处理状态
		dealClass(data) {
			let msg = ''
			switch (data) {
				case 0:
					msg = 'cyan-state'
					break
				case 1:
					msg = 'green-state'
					break
				case 2:
					msg = 'gray-state'
					break
				case 3:
					msg = 'red-state'
					break
				case 4:
					msg = 'cyan-state'
					break
			}
			return msg
		},
	},
}
</script>
<style lang="less" scoped>
.search {
	border-bottom: 1px solid #2671cc;
}
.content-header{
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 0;
	.title {
		padding-left: 10px;
		border-left: 4px solid #2671cc;
		font-size: 14px;
		color: #202020;
	}
	.blue{
		font-size: 18px;
		color: #2671cc;
	}
}
</style>
